import { useContext, useEffect, useRef } from 'react';

import { FeedbackUIContext } from '#context/feedback-ui-context';

export interface TagRow {
  id: number;
  name: string;
  productCount: number;
  createdAt?: string;
  updatedAt?: string;
}

// Global backdrop while the first fetch is in flight; hidden on unmount.
export function useInitialLoadOverlay(isLoading: boolean) {
  const { showBackdrop, hideBackdrop } = useContext(FeedbackUIContext)!;
  const activeRef = useRef(false);

  useEffect(() => {
    if (isLoading && !activeRef.current) {
      showBackdrop();
      activeRef.current = true;
    } else if (!isLoading && activeRef.current) {
      hideBackdrop();
      activeRef.current = false;
    }
  }, [isLoading]);

  useEffect(() => () => {
    if (activeRef.current) hideBackdrop();
  }, []);
}

export function useQueryErrorSnackbar(query: { error?: unknown }) {
  const { simpleSnackbar } = useContext(FeedbackUIContext)!;
  useEffect(() => {
    simpleSnackbar(query as unknown as Parameters<typeof simpleSnackbar>[0]);
  }, [query.error]);
}
